import { render, staticRenderFns } from "./FileMaster.vue?vue&type=template&id=1283c11c"
import script from "./FileMaster.vue?vue&type=script&lang=js"
export * from "./FileMaster.vue?vue&type=script&lang=js"
import style0 from "./FileMaster.vue?vue&type=style&index=0&id=1283c11c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports